import { customColorPalette } from 'common/theme.js';
export const menuIconTheme = {
icon: {
    color:"#ffffff"

}
}